import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { STORAGE_BUCKET_ORIGIN } from "../../../config/constants";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ProductService } from "../../../services/product-service";
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ReportService } from "../../../services/reports-service";
import '../../../assets/css/style.css';

// Register custom fonts with Quill
let Font = Quill.import("attributors/style/font");
Font.whitelist = ['UNEmanee', 'Outfit'];
Quill.register(Font, true);

const modules = {
  toolbar: [
      [{ 'font': Font.whitelist }],
      [{ 'size': [] }],
      ['bold', 'italic', 'underline', 'strike','blockquote'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      ['link', 'image', 'video'],
      [{ 'align': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'direction': 'rtl' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ],
}

const formats = [
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'color',
  'background',
  'script',
  'link',
  'image',
  'video',
  'align',
  'list',
  'bullet',
  'direction',
  'indent',
  'header'
];

export const Productlist = (props) => {
  const { productID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);
  const [isShow, setIsShow] = useState(true);

  const [mainUploadedFile, setMainUploadedFile] = useState();
  const [imagePreviews, setImagePreviews] = useState([]);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [mediums, setMediums] = useState([]);
  const [ isButtonValid, setIsButtonValid ] = useState(false);

  const [descripValue, setDescripValue] = useState("");

  const handleSlugChange = (e, setFieldValue) => {
    const value = e.target.value;
    const formattedSlug = value.toLowerCase()
                              .replace(/ /g, '_')
                              .replace(/[^\w-]+/g, '');
    setFieldValue('slug', formattedSlug);
};

const handleSeoTitleChange = (e, setFieldValue) => {
  const value = e.target.value;
  const formattedSlug = value.toLowerCase()                   // Convert to lowercase
                              .replace(/[^a-z0-9\s-]/g, '')    // Remove special characters
                              .trim()                          // Remove leading/trailing spaces
                              .replace(/\s+/g, '_')            // Replace spaces with hyphens
                              .replace(/-+/g, '_');  
  setFieldValue("slug", formattedSlug);
  setFieldValue("seo_title", value);
};


  var bodyFormData = new FormData();

  const [uploadedFile, setUploadedFile] = useState();

  const handleFileChange = (e) => {
    const filesArray = Array.from(e.target.files);
    const previews = filesArray.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
    setSelectedFiles({'files': e.target.files});
    setIsShow(false)
  };

  const handleStockChange = async (event) => {
    const newStockCount = event.target.value;
    let arrayList=[];
    arrayList = await Promise.all(props.groupProductsinfo.map(async (gProduct) => {

      const result = await ProductService.productDetailsID(gProduct.product_id);
      const calculatedNewStock = newStockCount * gProduct.quantity;

      if(result.stock < calculatedNewStock){
        notifyWarning('Available only ' + result.stock + ' in ' + result.name + ' stock.')
        return result.id
      }
    }))

    if(arrayList.filter(Number).length){
      setIsButtonValid(true);
    }else{
      setIsButtonValid(false);
    }
  };

  const staticGetAll = async () => {
    try {
      const result = await ReportService.staticDetails();
      setPublishers(result.publishers);
      setSubjects(result.subjects);
      setMediums(result.mediums);
      setCategories(result.categoriesOrderByOrderId);
    } catch (err) {
      //toast
      console.error(err);
    }
  };
  
  useEffect(() => {
    staticGetAll();
    // setDescripValue(props.description);
  },[])

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    if(selectedFiles.files){
      for(const key of Object.keys(selectedFiles.files)){
        bodyFormData.append('files', selectedFiles.files[key])
      }
    }

    if(mainUploadedFile){
      bodyFormData.append("main_image", mainUploadedFile);
    }

    bodyFormData.append("name", values.name);
    bodyFormData.append("description", values.description);
    bodyFormData.append("weight", values.weight);
    bodyFormData.append("youtube_video", values.youtube_video);
    bodyFormData.append("publisher", values.publisher);
    bodyFormData.append("subject", values.subject);
    bodyFormData.append("medium", values.medium);
    bodyFormData.append("type", values.type);
    bodyFormData.append("grade", values.grade);
    bodyFormData.append("level3cat", values.level3cat);
    bodyFormData.append("price", values.price);
    bodyFormData.append("stock", values.stock);
    bodyFormData.append("low_stock", values.low_stock);
    bodyFormData.append("product_group_type", values.product_group_type);
    bodyFormData.append("status", values.status);
    bodyFormData.append("seo_title", values.seo_title);
    bodyFormData.append("seo_description", values.seo_description);
    bodyFormData.append("seo_keyword", values.seo_keyword);
    bodyFormData.append("slug", values.slug);
    bodyFormData.append("img_alt", values.img_alt);
    bodyFormData.append("sort_order", values.sort_order);

    try {
      await ProductService.productUpdate(productID, bodyFormData);

      setSubmitLoading(true);
      notify("Product successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
        notifyWarning(err.response.data.message[0]);
      } else {
        notifyWarning("Something Wrong");
      }
      //show error toast
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Product</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  name: props.name,
                  main_image: props.main_image,
                  description: props.description,
                  weight: props.weight,
                  youtube_video: props.youtube_video,
                  publisher: props.publisher,
                  subject: props.subject,
                  medium: props.medium,
                  type: props.type,
                  grade: props.grade,
                  price: props.price,
                  discountPrice: props.discountPrice,
                  stock: props.stock,
                  low_stock: props.low_stock,
                  product_group_type: props.product_group_type,
                  level3cat: props.category,
                  files: props.files,
                  status: props.status,
                  seo_title: props.seo_title,
                  slug: props.slug,
                  seo_description: props.seo_description,
                  seo_keyword: props.seo_keyword,
                  img_alt: props.img_alt,
                  sort_order: props.sort_order,
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string()
                    .required("Required")
                    .min(2, "name must have at least 2 characters")
                    .max(100, "name must have less than 50 characters"),
                  weight: Yup.string().required("Required"),
                  publisher: Yup.string().required("Required"),
                  subject: Yup.string().required("Required"),
                  medium: Yup.string().required("Required"),
                  type: Yup.string().required("Please, select type"),
                  grade: Yup.string().required("Required"),
                  price: Yup.string().required("Required"),
                  product_group_type: Yup.string().required("Please, select group type"),
                  status: Yup.string().required("Please, select an status"),
                  stock: Yup.string().required("Required"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                  setFieldValue,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Name</label>
                        <div className="input-group">
                          <input
                            name="name"
                            type="text"
                            className="form-control"
                            id="nameid"
                            placeholder="Name"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.name && errors.name}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Weight</label>
                        <div className="input-group">
                          <input
                            name="weight"
                            type="text"
                            className="form-control"
                            id="weightid"
                            placeholder="weight"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.weight}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.weight && errors.weight}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-12 mb-5">
                        <label htmlFor="validationCustom08">Description</label>
                        <div className="input-group">
                          <ReactQuill 
                                theme="snow" 
                                name="description" 
                                className="editor-input"
                                value={values.description} 
                                onChange={(value) => {
                                  // setDescripValue(value);
                                  setFieldValue('description', value);
                                }}
                                modules={modules}
                                formats={formats}
                              />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.description && errors.description}
                        </div>
                      </div>
                    </div>
                    <div className="form-row mt-4">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Youtube Video(Embedded URL)</label>
                        <div className="input-group">
                          <input
                            name="youtube_video"
                            type="text"
                            className="form-control"
                            id="youtubeid"
                            placeholder=""
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.youtube_video}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.youtube_video && errors.youtube_video}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Publisher</label>
                        <div className="input-group">
                          <select
                            name="publisher"
                            className="form-control"
                            id="publisherid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.publisher}
                          >
                            <option value="">Select Publisher</option>
                            {publishers.map((publisher) => {
                              return(
                                <option key={publisher.id} value={publisher.id}>{publisher.name}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.publisher && errors.publisher}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Subject</label>
                        <div className="input-group">
                          <select
                            name="subject"
                            className="form-control"
                            id="subjectid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.subject}
                          >
                            <option value="">Select Subject</option>
                            {subjects.map((subject) => {
                              return(
                                <option key={subject.id} value={subject.id}>{subject.name}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.subject && errors.subject}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Medium</label>
                        <div className="input-group">
                          <select
                            name="medium"
                            className="form-control"
                            id="mediumid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.medium}
                          >
                            <option value="">Select Medium</option>
                            {mediums.map((medium) => {
                              return(
                                <option key={medium.id} value={medium.id}>{medium.name}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.medium && errors.medium}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom15">
                          Type
                        </label>
                        <div className="input-group">
                          <select
                            name="type"
                            className="form-control"
                            id="typeID"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.type}
                          >
                            <option value="">Select Type</option>
                            <option value="Theory">Theory</option>
                            <option value="Revision">Revision</option>
                            <option value="Practical">Practical</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.category_id && errors.category_id}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom15">Grade</label>
                        <div className="input-group">
                          <select
                            name="grade"
                            className="form-control"
                            id="grade"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.grade}
                          >
                            <option value="">Select Grade</option>
                            <option value="12">Grade 12</option>
                            <option value="13">Grade 13</option>
                            <option value="12/13">Grade 12 - 13</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.sub_category_id && errors.sub_category_id}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Price</label>
                        <div className="input-group">
                          <input
                            name="price"
                            type="text"
                            className="form-control"
                            id="priceid"
                            placeholder=""
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.price}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.price && errors.price}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Discount Price</label>
                        <div className="input-group">
                          <input
                            name="discountprice"
                            type="text"
                            className="form-control"
                            id="discountpriceid"
                            placeholder=""
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.discountPrice}
                            disabled
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.discountPrice && errors.discountPrice}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Product Group Type</label>
                        <div className="input-group">
                          <select
                            name="product_group_type"
                            className="form-control"
                            id="grouptypeid"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.product_group_type}
                            disabled
                          >
                            <option value="">Select Group Type</option>
                            <option value="single">Single</option>
                            <option value="group">Group</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.product_group_type && errors.product_group_type}
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label htmlFor="validationCustom08">Stock</label>
                        <div className="input-group">
                          <input
                            name="stock"
                            type="number"
                            className="form-control"
                            id="stockid"
                            placeholder=""
                            onChange={(e) => {
                              setFieldValue('stock', e.target.value)
                              handleStockChange(e);
                            }}
                            onBlur={handleBlur}
                            value={values.stock}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.stock && errors.stock}
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label htmlFor="validationCustom08">Low Stock</label>
                        <div className="input-group">
                          <input
                            name="low_stock"
                            type="number"
                            className="form-control"
                            id="lowstockid"
                            placeholder=""
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.low_stock}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.low_stock && errors.low_stock}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Category</label>
                        <div className="input-group">
                          <select
                            name="level3cat"
                            className="form-control"
                            id="level3catid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.level3cat}
                          >
                            <option value="">Select Category</option>
                            {categories.map((category) => {
                              return(
                                <option key={category.id} value={category.id}>{category.name}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.level3cat && errors.level3cat}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom15">
                          Change Status
                        </label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="selectstatus"
                            required
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="DISABLED">DEACTIVE</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.status && errors.status}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom08">Upload Main Image</label>
                        <div>
                        {props.main_image && <img
                            alt=""
                            src={
                              mainUploadedFile != null
                                ? URL.createObjectURL(mainUploadedFile)
                                : `${STORAGE_BUCKET_ORIGIN}${props.main_image}`
                            }
                            style={{ height: "100px" }}
                          />}
                        </div>
                        <div className="input-group mt-2">
                          <input
                            id="mainupload"
                            type="file"
                            name="main_image"
                            onBlur={handleBlur}
                            onChange={(event) => {
                              setMainUploadedFile(event.currentTarget.files[0]);
                              setFieldValue("main_image", "file");
                            }}
                          />

                          <div style={{ color: "red", fontSize: "12px" }}>
                            {touched.image && errors.image}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Upload Other Images</label>
                          {isShow && <div>
                            {props.images && props.images.map((image, index) => {
                              return(
                                <img
                                key={index}
                                alt=""
                                src={`${STORAGE_BUCKET_ORIGIN}${image.url}`
                                }
                                style={{ height: "100px" }}
                              />
                            )
                            })}
                          </div>}
                          <div>
                            {imagePreviews.map((preview, index) => (
                              <img 
                                key={index}
                                src={preview}
                                alt={`Preview ${index}`}
                                style={{width: '100px', height: '100px', marginRight: "10px"}}
                              />
                            ))}
                          </div>
                          <div className="input-group mt-2">
                            <input
                              id="filesupload"
                              type="file"
                              name="files"
                              multiple
                              onBlur={handleBlur}
                              onChange={(event) => {
                                handleFileChange(event)
                                setFieldValue("files", event.target.files);
                              }}
                            />

                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.files && errors.files}
                            </div>
                          </div>
                      </div>
                    </div>

                    <div className="form-row mt-5 mb-4">
                          <h6>SEO Section</h6>
                        </div>
                        <div className="form-row">
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">Seo Title</label>
                            <div className="input-group">
                              <input
                                name="seo_title"
                                type="text"
                                className="form-control"
                                id="seoTitleid"
                                placeholder="seo title"
                                required
                                onChange={(e) => handleSeoTitleChange(e, setFieldValue)}
                                onBlur={handleBlur}
                                value={values.seo_title}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.seo_title && errors.seo_title}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Slug
                            </label>
                            <div className="input-group">
                              <input
                                name="slug"
                                type="text"
                                className="form-control"
                                id="slugid"
                                placeholder="slug"
                                required
                                onChange={(e) => handleSlugChange(e, setFieldValue)}
                                onBlur={handleBlur}
                                value={values.slug}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.slug && errors.slug}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Meta Description
                            </label>
                            <div className="input-group">
                              <textarea
                                  name="seo_description"
                                  className="form-control"
                                  id="seoDescripid"
                                  placeholder="description"
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.seo_description}
                                  rows="3"
                                />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.seo_description && errors.seo_description}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Seo Keywords (Keywords need to be comma-separated)
                            </label>
                            <div className="input-group">
                              <textarea
                                  name="seo_keyword"
                                  className="form-control"
                                  id="seoKeywordpid"
                                  placeholder="keywords"
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.seo_keyword}
                                  rows="3"
                                />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.seo_keyword && errors.seo_keyword}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Image Alt
                            </label>
                            <div className="input-group">
                              <input
                                name="img_alt"
                                type="text"
                                className="form-control"
                                id="imgAltid"
                                placeholder="Image Alt"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.img_alt}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.img_alt && errors.img_alt}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Sort Order Id
                            </label>
                            <div className="input-group">
                              <input
                                name="sort_order"
                                type="text"
                                className="form-control"
                                id="orderid"
                                placeholder="Enter sort order Ex:1/1.1"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sort_order}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.sort_order && errors.sort_order}
                            </div>
                          </div>
                        </div>

                    
                    {/* <div className="col-md-12 mb-6">
                      <label htmlFor="validationCustom25">Description</label>
                      <Editor />
                    </div> */}
                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>

                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                        disabled={isButtonValid}
                      >
                        Save and Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productlist;
